var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-2xl mx-auto"},[_c('v-date-picker',{attrs:{"value":_vm.group.delivery.date,"allowed-dates":_vm.allowedDates},on:{"input":_vm.updateGroupDeliveryDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }